import ConfigService from "./config-service";
import ePharmaServices from "./epharma-services";
import keys from "../util/keys";
import { ICouponRequest } from "../interfaces/coupon";

class CouponBuilderService {

    static getBenefits = async () =>
    {
        const baseUrl = window.momentaMaisService.base;
        const benefitUrl = await ConfigService().getConfig(keys.EndpointBeneficiaryBeneficiary);

        const response = await ePharmaServices(baseUrl).get(benefitUrl);

        return response.data;
    }

    static generateCoupons = async (request: ICouponRequest) =>
    {
        const baseUrl = window.momentaMaisService.base;
        const generateCouponUrl = await ConfigService().getConfig(keys.EndpointMomentaMaisGenerateCoupon);

        const response = await ePharmaServices(baseUrl).post(`${generateCouponUrl}`, request);

        return response.data;
    }
}
    export default CouponBuilderService;
